module.exports = __webpack_public_path__ + "img/calendario.734e5b72.png";